import { Component, Input } from "@angular/core";
import { filter, isEmpty } from "lodash";
import { NavigationService } from "../../../navigation/navigation.service";
import { OfflineAsmtDataServiceProvider } from "../../../providers/offline-asmt-data-service/offline-asmt-data-service";
import { getUnplannedPatientName } from "../../../providers/offline-manager/offline-globals";
import { PatientDataManager } from "../../../providers/offline-manager/patient-data-manager";

/**
 * Generated class for the BriefBarComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: "create-visit-offline",
  templateUrl: "create-visit-offline.html",
})
export class CreateVisitOffline {
  levelOfCareOptions;
  patientId: number;
  levelOfcare: string;
  @Input() userId: any;
  @Input() patientList: any = [];

  constructor(
    public navSvc: NavigationService,
    public patientDataManager: PatientDataManager,
    public offlineAsmtDataServiceProvider: OfflineAsmtDataServiceProvider
  ) {
    this.offlineAsmtDataServiceProvider.getLevelOfCare().subscribe((data) => {
      this.levelOfCareOptions = data;
    });
  }

  ngOnInit(): void {
    this.userId = this.userId;
    this.patientList = this.patientList;
  }

  createPatientVisit() {
    let offlinePatients = filter(this.patientList, {
      chartId: Number(this.patientId),
    });
    if (isEmpty(offlinePatients)) {
      let patientObj = {
        chartId: this.patientId,
        userId: this.userId,
        patientFullName: getUnplannedPatientName(this.patientId),
        levelOfCare: this.levelOfcare,
        patientGender: "M",
      };
      this.patientDataManager
        .createUnplannedPatient(patientObj)
        .subscribe(() => {
          this.navigateToPatient();
        });
    } else {
      this.navigateToPatient();
    }
  }

  navigateToPatient() {
    this.navSvc.goToInternalPage("VisitsPage", { patChartId: this.patientId });
  }
}



// WEBPACK FOOTER //
// ./src/navigation/components/create-visit-offline/create-visit-offline.ts